"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = _interopRequireDefault(require("../../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import PropTypes from 'prop-types';
var Playhead = function Playhead(_ref) {
  var onSeek = _ref.onSeek,
      _ref$progress = _ref.progress,
      progress = _ref$progress === void 0 ? 0 : _ref$progress,
      isSentimentAnalyzerOn = _ref.isSentimentAnalyzerOn,
      isChatTextMedia = _ref.isChatTextMedia;
  return /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    style: {
      padding: 0,
      position: "relative"
    }
  }, /*#__PURE__*/_react["default"].createElement(_components["default"].TimelinePlayhead, {
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "none",
    onClick: isChatTextMedia ? null : onSeek,
    isSentimentAnalyzerOn: isSentimentAnalyzerOn //   style={{backGround:'red'}}

  }, /*#__PURE__*/_react["default"].createElement("line", {
    vectorEffect: "non-scaling-stroke",
    strokeWidth: "1",
    stroke: "rgba(0, 0, 0, 0.2)",
    style: {
      shapeRendering: "crispEdges"
    },
    y1: "0",
    y2: "100%",
    x1: progress + "%",
    x2: progress + "%"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    // width={`${progress}%`}
    width: "100%",
    height: "100%",
    opacity: "0.00"
  })))));
};

var _default = Playhead;
exports["default"] = _default;